import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "image", "thumbnail"]

  connect() {
    this.currentIndex = 0
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    const clickedButton = event.currentTarget
    this.currentIndex = this.thumbnailTargets.indexOf(clickedButton)
    this.showImage(this.currentIndex)
    this.dialogTarget.showModal()
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    this.dialogTarget.close()
    this.imageTarget.src = ""
    document.removeEventListener("keydown", this.handleKeydown)
  }

  previous() {
    if (this.thumbnailTargets.length === 0) return
    this.currentIndex = (this.currentIndex - 1 + this.thumbnailTargets.length) % this.thumbnailTargets.length
    this.showImage(this.currentIndex)
  }

  next() {
    if (this.thumbnailTargets.length === 0) return
    this.currentIndex = (this.currentIndex + 1) % this.thumbnailTargets.length
    this.showImage(this.currentIndex)
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.previous()
    } else if (event.key === "ArrowRight") {
      event.preventDefault()
      this.next()
    } else if (event.key === "Escape") {
      this.close()
    }
  }

  showImage(index) {
    const button = this.thumbnailTargets[index]
    this.imageTarget.src = button.dataset.galleryFullSrcParam
  }
}
